import { AppState } from '@/types';

import {
  AcceptLeadsPassingModalConfig,
  SubmitOrderModalConfig,
  TrainingRequiredModalConfig,
} from './types';

export const selectGlobalError = (state: AppState): Error | null => {
  return state.global.error || null;
};

export const selectTrainingRequiredModalConfig = (state: AppState): TrainingRequiredModalConfig => {
  return state.global.trainingRequiredModal;
};

export const selectSubmitOrderModalConfig = (state: AppState): SubmitOrderModalConfig => {
  return state.global.submitOrderModal;
};

export const selectAcceptLeadsPassingModalConfig = (
  state: AppState,
): AcceptLeadsPassingModalConfig => {
  return state.global.acceptLeadsPassingModal;
};
